/**
 * NotifyCard — clickable card used on the admin dashboard home for KPIs and
 * day notifications (Check-in / Check-out / Extras / In-house). Shows a red
 * pulsating dot when `hasNew` is true.
 *
 * Extracted from AdminDashboardPage.jsx (iter114 refactor).
 */
const NotifyCard = ({ icon: Icon, label, value, accent, hasNew, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    title={`Apri ${label}`}
    className="relative text-left bg-white border border-[#E8E2D9] hover:border-[#AC5D45] hover:shadow-md hover:-translate-y-0.5 active:scale-[0.98] cursor-pointer rounded-xl p-5 transition-all duration-150 group"
  >
    {hasNew && (
      <span className="absolute top-3 right-3 inline-flex h-3 w-3" data-testid={`${testId}-dot`}>
        <span className="absolute inline-flex h-full w-full rounded-full bg-rose-500 opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-rose-600" />
      </span>
    )}
    <div className={`flex items-center gap-2 mb-3 ${accent || "text-[#635F59]"}`}>
      <Icon className="w-4 h-4" />
      <span className="text-xs uppercase tracking-wider">{label}</span>
    </div>
    <div className="font-display text-3xl text-[#1E3A5F] group-hover:text-[#AC5D45] transition">{value}</div>
    <div className="absolute bottom-2 right-3 text-[10px] text-[#AC5D45] opacity-0 group-hover:opacity-100 transition font-semibold">
      apri →
    </div>
  </button>
);

export default NotifyCard;
